import logo from './logo.svg';
import './App.css';
import { Route, Routes } from "react-router-dom";
import HomePage from "./home";
import NotFoundPage from './404';
import 'bootstrap/dist/css/bootstrap.min.css';
import UpcomingEvents from "./upcoming-events";
import CultivationStories from "./cultivationStories";
import QAndA from "./qAndA";
import OnlineClass from "./onlineClass";
import Blog from "./blog";
import Lectures from "./lecture";
import AvatamsakaSutraContent from "./avatamsakaSutra";
import SixthPatriarchSutraContent from "./sixthPatriarchSutra";
import Activities from "./activities";
import FoQi from "./foqi";
import ChanQi from "./chanqi";
import Livestream from "./livestream";

import Relics from "./relics";
import Publications from "./publication";
import Training from "./training";
import Practices from "./practices";
import Ceremonies from "./ceremonies";
import Contribution from "./contribution";
import Master from "./master";
import Calendar from "./calendar";
import StatementOfFaith from "./statement-of-faith";
import Location from "./location";

function App() {
  return (

      <Routes>
      <Route exact path="/" element={<HomePage />} />
      <Route path="/upcoming-events" element={<UpcomingEvents/>} />
<Route path="/cultivation-stories" element={<CultivationStories/>} />
<Route path="/qanda" element={<QAndA />} />
<Route path="/onlineClass" element={<OnlineClass />} />
<Route path="/blog" element={<Blog />} />
<Route path="/lecture" element={<Lectures />} />
<Route path="/avatamsaka-sutra" element={<AvatamsakaSutraContent />} />
<Route path="/sixth-patriarch-sutra" element={<SixthPatriarchSutraContent />} />
<Route path="/heart-sutra" element={<SixthPatriarchSutraContent />} />
<Route path="/vajra-sutra" element={<SixthPatriarchSutraContent />} />
<Route path="/amitabha-sutra" element={<SixthPatriarchSutraContent />} />
<Route path="/earth-store-sutra" element={<SixthPatriarchSutraContent />} />
<Route path="/medicine-master-sutra.html" element={<SixthPatriarchSutraContent />} />
<Route path="/the-bequeathed-teaching-sutra" element={<SixthPatriarchSutraContent />} />
<Route path="/the-sutra-in-42-sections"element={<SixthPatriarchSutraContent />} />
<Route path="/dharmatalk-901788"element={<SixthPatriarchSutraContent />} />
<Route path="/dharmatalk"element={<SixthPatriarchSutraContent />} />
<Route path="/fo-qi-archive"element={<SixthPatriarchSutraContent />} />
<Route path="/chan-qi-archive"element={<SixthPatriarchSutraContent />} />
<Route path="/outreach-archive" element={<SixthPatriarchSutraContent />} />
<Route path="/activities" element={<Activities />} />
<Route path="/livestream" element={<Livestream />} />
<Route path="/foqi" element={<FoQi />} />
<Route path="/chanqi" element={<ChanQi />} />
<Route path="/relics"
 element={<Relics />} />
<Route path="/publication" element={<Publications />} />
<Route path="/training" element={<Training />} />
<Route path="/practices" element={<Practices />} />
<Route path="/ceremonies" element={<Ceremonies />} />
<Route path="/contribution" element={<Contribution />} />
<Route path="/master" element={<Master />} />
<Route path="/calendar" element={<Calendar />} />
<Route path="/statement-of-faith" element={<StatementOfFaith />} />
<Route path="/location" element={<Location />} />
      <Route path="*" element={<NotFoundPage />} />  {/* 404 Route */}
    </Routes>
  );
}

export default App;
